<template>
    <span class="tariff-restriction-notice">
        <slot name="before" />

        <!-- Teachers/admins can open tariffs; students only see plain text -->
        <router-link
            v-if="canOpenTariffs"
            class="tariff-restriction-notice__link"
            :to="tariffsRoute"
        >
            <slot>{{ linkWord }}</slot>
        </router-link>
        <span v-else>
            <slot>{{ linkWord }}</slot>
        </span>

        <slot name="after" />
    </span>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'TariffRestrictionNotice',
        props: {
            // Word that becomes a clickable link when the user can open /tariffs
            linkWord: {
                type: String,
                default: 'тариф',
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            canOpenTariffs() {
                return Boolean(this.user) && this.user.type !== 'student';
            },
            tariffsRoute() {
                return { name: 'tariffs:list' };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tariff-restriction-notice__link {
        color: #3498db;
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: #2980b9;
        }
    }
</style>
